import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    country: {
      label: {
        id: 'properties.country',
        defaultMessage: 'Country',
        description: 'label of the form field country',
      },
    },
    method: {
      label: {
        id: 'properties.shippingMethod',
        defaultMessage: 'Shipping method',
        description: 'label of the form field shipping method',
      },
    },
    postalCode: {
      label: {
        id: 'properties.postalCode',
        defaultMessage: 'Postal code',
        description: 'label of the form field postal code',
      },
    },
    servicePoint: {
      label: {
        id: 'properties.servicePoint',
        defaultMessage: 'Service point',
        description: 'label of the form field service point',
      },
    },
    isSplitAllowed: {
      label: {
        id: 'properties.isSplitAllowed',
        defaultMessage: 'Split allowed',
        description: 'label of the form field is split allowed',
      },
    },
    deliveryAt: {
      label: {
        id: 'properties.deliveryAt',
        defaultMessage: 'Delivery at',
        description: 'label of the form field delivery at',
      },
    },
  },
};

export default defineMessages(translations);
